import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueYtframe from "vue3-ytframe";
import { VueWindowSizePlugin } from "vue-window-size/plugin";

require("./assets/main.scss");

createApp(App)
  .use(VueYtframe)
  .use(VueWindowSizePlugin)
  .use(router)
  .mount("#app");
